// 其他接口
import request from "../request";

export default {
  // 获取banner
  getBanner(params) {
    return request({
      url: `web/sys-banner/front/listFrontBanner`,
      method: "get",
      params,
    });
  },
  // 获取公司
  getCompany(params) {
    return request({
      url: `web/sys-company/front/listFrontCompany`,
      method: "get",
      params,
    });
  },
  // 获取招聘信息
  getJob(params) {
    return request({
      url: `web/sys-job/front/listFrontJob`,
      method: "get",
      params,
    });
  },
  // 查询所有新闻
  getAllNews(params) {
    return request({
      url: `web/sys-news/front/listFrontSysNews`,
      method: "get",
      params: { ...params, newsType: 0 },
    });
  },
  // 分页查询案例
  getCaseList(params) {
    return request({
      url: `web/sys-news/front/pageFrontSysNewsList`,
      method: "get",
      params: { ...params, newsType: 1 },
    });
  },
  // 查询新闻详情
  getNewDetail(id) {
    return request({
      url: `web/sys-news/front/${id}`,
      method: "get",
    });
  },
  // 新增留言
  addFeedBack(data) {
    return request({
      url: `web/sys-feedback/system`,
      method: "post",
      data,
    });
  },
  // 获取配置
  getConfig(params) {
    return request({
      url: `web/sys-web-config/front/listConfig`,
      method: "get",
      params,
    });
  },
  // 获取友情链接
  getFriendlink(params) {
    return request({
      url: `web/sys-friend-link/front/getFrontList`,
      method: "get",
      params,
    });
  },
};
